
import { TOTALUSERS,DAILY_REVENUE,MONTHLYREVENUE,TOTALREVENUE, SALESDATA } from './../constants/actionTypes';
import * as api from './../api/index.js';

  export const total_user = (formData) => async (dispatch) => {
    try {
      const { data } = await api.total_user(formData);
      
      dispatch({ type: TOTALUSERS, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };


  export const monthly_revenue = (formData) => async (dispatch) => {
    try {
      const { data } = await api.monthly_revenue(formData);
      
      dispatch({ type: MONTHLYREVENUE, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };

  export const total_revenue = (formData) => async (dispatch) => {
    try {
      const { data } = await api.total_revenue(formData);
      
      dispatch({ type: TOTALREVENUE, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };



  export const daily_revenue = (formData) => async (dispatch) => {
    try {
      const { data } = await api.daily_revenue(formData);
      
      dispatch({ type: DAILY_REVENUE, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };
  


  export const sales_dashboard = (formData) => async (dispatch) => {
    try {
      const { data } = await api.sales_dashboard(formData);
      
      dispatch({ type: SALESDATA, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };




  